import React from "react";
import { DataTable } from "../Component";

function DataTableShell({ children, scrollable = true, className = "" }) {
  const tableClass = ["card-stretch", className].filter(Boolean).join(" ");
  return (
    <DataTable className={tableClass} scrollable={scrollable}>
      {children}
    </DataTable>
  );
}

export default DataTableShell;
